import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import MaskInput from 'components/MaskedInput';
import { unMaskInputValue } from 'utils/helpers';
import { useStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/hooks/useStatusBoard';

type TargetStatusFieldProps = {
  isGerman?: boolean;
  titleHidden?: boolean;
  withButtons?: boolean;
};

const TargetStatusField = ({ isGerman = false, titleHidden = false, withButtons = false }: TargetStatusFieldProps) => {
  const {
    setTargetPh,
    targetph,
    errorTarget,
  } = isGerman ? useGermanStatusBoard() : useStatusBoard();

  return (
    <div>
      <MaskInput
        className="w-full h-[48px] w-[536px]"
        titleClassName="top-[-9px] left-[8px]"
        title={titleHidden ? '' : 'pH'}
        onChange={setTargetPh}
        value={unMaskInputValue(targetph)}
        integerLimit={1}
        decimalLimit={2}
        isGreyText={isGerman}
        redBorder={errorTarget.length > 0}
        withButtons={withButtons}
        suffix={titleHidden ? ' pH' : ''}
        enforceDecimalPlaces={true}
        isBlueBg
      />

      <div className="text-[#FF3B30] text-xs mt-1 min-h-[16px] break-words">
        {errorTarget.length > 0 && <span> {errorTarget}</span>}{' '}
      </div>
    </div>
  );
};

export default TargetStatusField;
